import React from 'react';
import { Link } from 'react-router-dom';
import { ListItem, ListItemText, ListItemIcon, Icon, IconButton } from '@material-ui/core';
import { get } from 'global/lib/lodash';
import { Loading, useScreen } from 'global/styles';
import moment from 'moment';
import TypoLabel from 'global/components/typo-label';
import useStyles from './TaskListAging.styles';
import { useDispatch, useSelector } from 'react-redux';
import { removeNewTask, addNewTask } from 'redux/actions/view';
import ScoreIcon from 'global/components/ScoreIcon';

export default function TaskListItem(props) {
  const { item, isTitle, tableRows, showChecks } = props;
  const classes = useStyles();
  const newTasks = useSelector((state) => get(state, 'view.task.new'));
  const dispatch = useDispatch();
  const isSelected = newTasks.find((t) => t.id === item.id);

  const { isMobile } = useScreen();

  const score = get(item, 'scorecardScore.score', null);

  const content = {
    ...item,
    realmType: get(item, 'type', Loading),
    label: get(item, 'realm.name', Loading),
    realmName: get(item, 'label', Loading),
    updatedDate: get(item, 'date', Loading),
    agingDate: get(item, 'createdAt', Loading),
    status: score === null ? 'N/A' : score < 0 ? 'N/O' : score === 100 ? 'PASS' : 'FAIL',
    checkTitles: get(item, 'checkTitle', 'Some content'),
    author: get(item, 'authors', [])
      .map((a) => get(a, 'name'))
      .join(', '),
    assignee: get(item, 'assignees', [])
      .map((a) => get(a, 'name'))
      .join(', '),
    standard: get(item, 'checkpoint.id') ? `${get(item, 'checkpoint.id', '')}: ${get(item, 'checkpoint.name', '')}` : Loading,
  };

  const onIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSelected) {
      dispatch(removeNewTask(item));
    } else {
      dispatch(addNewTask({ ...item, fromSelected: true }));
    }
  };

  const dayDiff = Math.abs(moment.utc(content.agingDate).startOf('day').diff(moment.utc().startOf('day'), 'days'));
  content.agingDate = `${dayDiff} days`;
  const iconColor = dayDiff >= 21 ? classes.red : dayDiff >= 7 ? classes.orange : classes.grey;
  const renderIcon = () => (
    <ListItemIcon>
      <IconButton onClick={onIconClick}>
        {showChecks ? (
          <ScoreIcon useBlankCheckbox={!isSelected} selected={isSelected} />
        ) : (
          <Icon fontSize="small" className={iconColor}>
            access_time
          </Icon>
        )}
      </IconButton>
    </ListItemIcon>
  );

  return (
    <ListItem component={Link} to={isTitle ? `/tasks/list` : `/tasks/detail/${item.id}`} button divider={true} key={item.id} disableGutters={true} style={{ padding: 0, pageBreakInside: 'avoid' }}>
      {renderIcon()}
      <ListItemText
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          isMobile ? (
            <>
              {tableRows.map((tr, i) => (
                <TypoLabel key={i} primary={`${tr.title}: `} secondary={tr.val(content)} />
              ))}
            </>
          ) : (
            <div className={classes.tableRow}>
              {tableRows.map((tr, i) => (
                <div key={i} style={{ width: tr.width, ...(tr.style || {}) }}>
                  {tr.val(content)}
                </div>
              ))}
            </div>
          )
        }
      />
    </ListItem>
  );
}
